import {useIntl} from 'react-intl'
import Tabs, {Tab} from 'react-best-tabs'
import 'react-best-tabs/dist/index.css'
import {Activites} from './Activites'
import {Contacts} from './Contacts'
import {Update} from './Update'
import {Profile} from './Profile'
import {KTSVG, toAbsoluteUrl} from '../../../../_metronic/helpers'
import {useEffect, useState} from 'react'
import {InvestorModel} from '../../investor-database/core/_models'
import {AddNewActivityModal} from '../views/AddNewActivityModal'
import {Filter} from '../../widgets/components/General/Filter'
import {AddInvestorUserModal} from '../../investor-database/view/AddInvestorUserModal'
import {activityModel} from '../core/_models'
import {useAuth} from '../../auth'
import {getAllActivities} from '../core/_requests'
import {AllInvestorUser} from '../../investor-database/core/_requests'
import {toast} from 'react-toastify'
import {InvestorUpdatesModel} from '../../investor-updates/core/_models'
import {getAllInvestorUpdatesAPI} from '../../investor-updates/core/_request'
import {roleValues} from '../../../core/_constants'

import '../../../../_metronic/layout/components/toolbar/styles/sidebar.scss'
export const InvestorNavBar = ({
  investor,
  getInvestor,
  activeRound,
  investorUserId,
}: {
  investor: InvestorModel
  getInvestor: () => void
  activeRound?: any
  investorUserId: string | undefined
}) => {
  const {formatMessage} = useIntl()
  const {companyId, role} = useAuth()
  const [selectedSideBar, setSelectedSideBar] = useState(1)
  const [selectedOption, setSelectedOption] = useState(1)
  const [activityModalShow, setActivityModalShow] = useState(false)
  const [key, setKey] = useState(1)
  const [allActivities, setAllActivities] = useState<[activityModel]>()
  const [activitySearch, setActivitySearch] = useState<string>('')
  const [modalShow, setModalShow] = useState(false)
  const [isActivityFilter, setIsActivityFilter] = useState<boolean>(false)
  const [sort_by_activity, set_sort_by_activity] = useState<string | undefined>(undefined)
  const [sort_order_activty, set_sort_order_activty] = useState<string | undefined>(undefined)
  const [allInvestorUser, setAllInvestorUser] = useState<any>([])
  const [selectedInvestorUser, setSelectedInvestorUser] = useState<{label: string; value: number}>()
  const [investorUpdatesData, setInvestorUpdatesData] = useState<
    InvestorUpdatesModel[] | undefined
  >()

  const onhandleChange = (event: any) => {
    setActivitySearch(event.target.value)
  }
  const [filterActivity, setFilterActivity] = useState<string | undefined>(undefined)

  const getActivity = async () => {
    let type: string = 'all'
    if (selectedSideBar === 1) {
      type = 'upcoming'
    }
    if (selectedSideBar === 2) {
      type = 'past'
    }
    if (companyId && investor?.investorId) {
      const {
        data: {data: values, success},
      } = await getAllActivities(
        companyId,
        investor?.investorId,
        type,
        activitySearch,
        filterActivity,
        sort_by_activity,
        sort_order_activty
      )
      if (success) {
        setAllActivities(values)
      }
    }
  }

  useEffect(() => {
    // if (role && role !== roleValues.BILLING) getActivity() // eslint-disable-next-line
    getActivity() // eslint-disable-next-line
  }, [
    companyId,
    investor?.investorId,
    selectedSideBar,
    activitySearch,
    filterActivity,
    sort_by_activity,
    sort_order_activty,
    role,
  ])

  const getAllInvestorUser = async () => {
    try {
      // if (activeRound?.roundId && investor?.investorId && role !== roleValues.BILLING) {
      if (activeRound?.roundId && investor?.investorId) {
        const {
          data: {data, success, errors},
        } = await AllInvestorUser(Number(investor?.investorId), activeRound?.roundId)
        if (success) {
          if (investorUserId) {
            const findInvestorUser = data.find(
              (investorUser: {investorUserId: number}) =>
                investorUser.investorUserId === +investorUserId
            )
            if (findInvestorUser) {
              setSelectedInvestorUser({
                label: findInvestorUser.name,
                value: findInvestorUser.investorUserId,
              })
            }
          }
          setAllInvestorUser(data)
        } else {
          errors.forEach((error: string) => {
            toast.error(formatMessage({id: error}))
          })
        }
      }
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    if (investor?.investorId) {
      getAllInvestorUser()
    }
  }, [investor?.investorId, activeRound?.roundId, role]) // eslint-disable-line react-hooks/exhaustive-deps

  const getAllInvestorUpdate = async () => {
    try {
      if (companyId && role && role === roleValues.OWNER) {
        if (selectedOption === 2) {
          const {
            data: {
              data: {investorUpdates},
              success,
            },
          }: any = await getAllInvestorUpdatesAPI(+companyId!, 1, 5, 'INTERNAL')
          if (success) {
            setInvestorUpdatesData([...investorUpdates])
          }
        } else if (selectedOption === 3) {
          const {
            data: {
              data: {investorUpdates},
              success,
            },
          }: any = await getAllInvestorUpdatesAPI(+companyId!, 1, 5, 'EXTERNAL')
          if (success) {
            setInvestorUpdatesData([...investorUpdates])
          }
        } else {
          const {
            data: {
              data: {investorUpdates},
              success,
            },
          }: any = await getAllInvestorUpdatesAPI(+companyId!, 1, 5)
          if (success) {
            setInvestorUpdatesData([...investorUpdates])
          }
        }
      }
    } catch (err) {
      console.log(err)
    }
  }
  useEffect(() => {
    getAllInvestorUpdate()
  }, [companyId, selectedOption, role]) // eslint-disable-line react-hooks/exhaustive-deps
  // const sidebarOptions = ['Akey', 'Contact', 'Updates', 'Profile']
  // const [sidebar, setSidebar] = useState(1)
  return (
    <>
      <div className='px-md-6'>
        <Filter
          isActivityFilter={isActivityFilter}
          set_sort_by_activity={set_sort_by_activity}
          set_sort_order_activty={set_sort_order_activty}
          setFilterActivity={setFilterActivity}
          setIsActivityFilter={setIsActivityFilter}
        />
        <div className='positon-relative mt-3 '>
          <div className='d-flex flex-md-row flex-column align-items-center gap-md-4 mb-3 mt-md-0 mt-5 tabs-right-container z-index-1'>
            <div className='d-flex align-items-center w-100 w-md-auto justify-content-between gap-3 mb-md-auto mb-3'>
              {key === 1 ? (
                <button
                  onClick={() => setIsActivityFilter(true)}
                  className='btn btn-sm btn-flex fw-bold bg-body btn-color-gray-700 btn-active-color-primary h-75 cursor-pointer height-36'
                  id='fc-toogle'
                  title='Sort and Filter'
                  data-bs-toggle='tooltip'
                  data-bs-placement='left'
                  data-bs-dismiss='click'
                  data-bs-trigger='hover'
                >
                  <KTSVG
                    path={
                      filterActivity || sort_by_activity || sort_order_activty
                        ? toAbsoluteUrl('/media/icons/duotune/general/gen031_selected.svg')
                        : toAbsoluteUrl('/media/icons/duotune/general/gen031.svg')
                    }
                    className='svg-icon-6 svg-icon-muted me-1'
                  />
                  <span className='d-md-block d-none m-0'>
                    {filterActivity || sort_by_activity || sort_order_activty
                      ? formatMessage({id: 'Filter*'})
                      : formatMessage({id: 'Filter'})}
                  </span>
                </button>
              ) : (
                ''
              )}

              {key === 1 && (
                <div className='d-flex flex-md-row align-items-center position-md-relative h-30px w-100 '>
                  <span className='svg-icon svg-icon-3 position-absolute ms-md-2 p-md-0 p-3'>
                    <img
                      src={toAbsoluteUrl('/media/icons/investor/search.svg')}
                      alt='search icon'
                    />
                  </span>
                  <input
                    type='text'
                    className=' form-control font-size-13 form-control-white form-control-sm w-100 ps-10'
                    placeholder='Search activity'
                    onChange={onhandleChange}
                  />
                </div>
              )}
            </div>

            <div className='d-md-flex gap-3 w-100 w-md-auto pe-md-3'>
              {key === 2 && (
                <button
                  className={`btn btn-sm btn-primary w-md-150px w-100 ms-md-0 ms-md-10 me-3 me-md-0`}
                  onClick={() => setModalShow(true)}
                >
                  {formatMessage({id: 'Add Contact'})}
                </button>
              )}

              {key === 1 && (
                <button
                  className={`btn btn-sm btn-primary w-md-150px w-100  ms-md-0 me-3 me-md-0`}
                  onClick={() => setActivityModalShow(!activityModalShow)}
                >
                  {formatMessage({id: 'Add Activity'})}
                </button>
              )}
            </div>
          </div>
          <Tabs
            activeTab={1}
            className=''
            ulClassName='text-muted dark-border setting-tabs'
            activityClassName='bg-primary'
            onClick={(event, tab) => setKey(tab)}
          >
            <Tab title={formatMessage({id: 'Activity'})} className='mr-3 mt-2'>
              <div className='mt-3'>
                <Activites
                  setSelectedSideBar={setSelectedSideBar}
                  allActivities={allActivities}
                  getActivity={getActivity}
                  investorId={investor?.investorId}
                  investorName={investor?.name}
                  selectedSideBar={selectedSideBar}
                  roundId={activeRound?.roundId}
                />
              </div>
            </Tab>
            <Tab title={formatMessage({id: 'Contact'})} className='mr-3 mt-2'>
              <div className='mt-3'>
                <Contacts
                  investorUsers={allInvestorUser}
                  investorId={investor?.investorId}
                  getInvestor={getInvestor}
                  getActivity={getActivity}
                  roundId={activeRound?.roundId}
                  investorName={investor?.name}
                />
              </div>
            </Tab>
            <Tab title={formatMessage({id: 'Updates'})} className='mr-3 mt-2'>
              <div className='mt-3'>
                <Update
                  investorUpdatesData={investorUpdatesData}
                  selectedOption={selectedOption}
                  setSelectedOption={setSelectedOption}
                />
              </div>
            </Tab>
            <Tab title={formatMessage({id: 'Profile'})} className='mr-3 mt-2'>
              <div className='mt-3'>
                <Profile individualInvestor={investor} />
              </div>
            </Tab>
          </Tabs>
          {/* <div className='mb-2 sidebar-investor-db col-md-1 d-flex ' style={{width: '100%'}}>
            <div
              className=' d-flex'
              style={{
                display: 'flex',
                overflowX: 'scroll',
                whiteSpace: 'nowrap',
                scrollbarWidth: 'none',
                msOverflowStyle: 'none',
              }}
            >
              {sidebarOptions.map((sideTabs: any, index: number) => (
                <>
                  <ul
                    className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5  flex-nowrap mobile-tab-both my-md-0 mb-2 '
                    style={{display: 'flex', flexWrap: 'nowrap'}}
                  >
                    <li
                      key={index}
                      className={
                        `nav-link text-active-primary py-3 ps-3 d-flex align-items-center` +
                        (sidebar === index + 1
                          ? '  border-top-0 border border-left-0 border-right-0 border-bottom-3 border-primary text-primary border-5'
                          : '')
                      }
                      onClick={() => setSidebar(index + 1)}
                    >
                      {sideTabs}
                    </li>
                  </ul>
                </>
              ))}
            </div>
          </div> */}
          <AddNewActivityModal
            investorName={investor?.name}
            modalShow={activityModalShow}
            setModalShow={setActivityModalShow}
            investorId={investor?.investorId}
            getActivity={getActivity}
            roundId={activeRound?.roundId}
            selectedInvestorUser={selectedInvestorUser}
          />
          <AddInvestorUserModal
            userModalShow={modalShow}
            setUserModalShow={setModalShow}
            id={investor?.investorId?.toString()}
            getInvestor={getInvestor}
          />
        </div>
      </div>
    </>
  )
}
